// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import scrollama from 'scrollama';
import resizer from './ai2html-resizer';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// Write your code!
// video

//scroll
var scroller = scrollama(),
  height,
  screenWidth,
  isMobile,
  landscape;

// console.log('init');

let classes = {
  2: {
    down: 'img-zoom',
    up: 'img1-pan-back',
  },
  3: {
    down: 'img1-pan',
    up: 'img1-pan', //filler
  },
  6: {
    down: 'img-zoom-lite', // zoom to doggy
    up: 'img-zoom-lite', //filler
  },
  7: {
    down: 'img-zoom-lite', // zoom to doggy
    up: 'img-zoom-lite', //filler
  },
  9: {
    down: 'img-zoom',
    up: 'img-zoom',
  },
  10: {
    down: 'img3-pan',
    up: 'img3-pan',
  },
  13: {
    down: 'img-zoom',
    up: 'img-zoom',
  },
  14: {
    down: 'img4-pan',
    up: 'img4-pan',
  },
};

// let classes = {
//   2: 'img-zoom',
//   3: 'img1-pan',
//   6: 'img-zoom-lite', // zoom to doggy
//   9: 'img-zoom',
//   10: 'img3-pan',
//   13: 'img-zoom',
//   14: 'img4-pan',
// };

let move = (z, dir, i) => {
  let imgElement = document.getElementById(`img${i}`);
  // if (z==16) {
  //   imgElement?.classList.add('img4-zoom-out')
  //   imgElement.classList.remove('img4-pan','img4-pan-back','img-zoom')

  // }else
  if (classes[z] && dir == 'down') {
    imgElement.classList.add(classes[z][dir]); //adding the appropriate class from classes dictionary
  } else if (classes[z] && dir == 'up') {
    if (classes[z + 1]) {
      imgElement.classList.remove(classes[z + 1]['down']);
    }
    imgElement.classList.add(classes[z][dir]);
  } else {
    imgElement.classList.remove(
      'img-zoom',
      'img-zoom',
      'img-zoom-lite',
      'img1-pan',
      'img1-pan-back',
      'img3-pan',
      'img3-pan-back',
      'img4-pan',
      'img4-pan-back'
    );
  }
};

let mobileClasses = {
  2: {
    down: 'img-zoom-m',
    up: 'img1-pan-back-m',
  },
  3: {
    down: 'img1-pan-m',
    up: 'img1-pan-m', //filler
  },
  6: {
    down: 'img-zoom-lite-m', // zoom to doggy
    up: 'img-zoom-lite-m', //filler
  },
  7: {
    down: 'img-zoom-lite-m', // zoom to doggy
    up: 'img-zoom-lite-m', //filler
  },
  9: {
    down: 'img-zoom-lite-m',
    up: 'img-zoom-lite-m',
  },
  10: {
    down: 'img3-pan-m',
    up: 'img3-pan-m',
  },
  13: {
    down: 'img-zoom-m',
    up: 'img-zoom-m',
  },
  14: {
    down: 'img4-pan-m',
    up: 'img4-pan-m',
  },
};

let moveMobile = (z, dir, i) => {
  let imgElement = document.getElementById(`img${i}`);

  if (mobileClasses[z] && dir == 'down') {
    imgElement.classList.add(mobileClasses[z][dir]); //adding the appropriate class from classes dictionary
  } else if (mobileClasses[z] && dir == 'up') {
    if (mobileClasses[z + 1]) {
      imgElement.classList.remove(mobileClasses[z + 1]['down']);
    }
    imgElement.classList.add(mobileClasses[z][dir]);
  } else {
    imgElement.classList.remove(
      'img1-pan-m',
      'img1-pan-back-m',
      'img3-pan-m',
      'img3-pan-back-m',
      'img4-pan-m',
      'img4-pan-back-m',
      'img-zoom-m',
      'img-zoom-lite-m'
    );
  }
};

let init = () => {
  height = window.innerHeight * 0.8;
  screenWidth = window.innerWidth;

  isMobile = screenWidth < 769;
  landscape = screenWidth > height;
  // console.log(screenWidth)
  // resizer();

  scroller
    .setup({
      step: '.captions .step',
      offset: isMobile ? '600px' : 0.75,
      debug: false,
      progress: false,
    })
    .onStepEnter((response) => {
      let z = response.index;
      let dir = response.direction;
      let i = response.element.dataset.step; //get datastep element so we can choose the right img

      // console.log(response);
      if (isMobile && !landscape) {
        moveMobile(z, dir, i);
        // console.log('mobile');
      } else {
        move(z, dir, i); // move function applied
      }
    })
    .onStepExit((response) => {});
  // setup resize event
  // window.addEventListener('resize', resizer);
};

init();
